module.exports = __webpack_public_path__ + "img/mars-stroke-up.e77fa8bf.svg";